module.exports = __webpack_public_path__ + "static/media/yellow_3.82cddbf0.jpg";